import { SortParams } from 'src/types/SortParams';

export const getOrder = (
  cellId: string,
  order: SortParams['order'],
  orderBy: string
): SortParams['order'] => {
  return orderBy === cellId && order === 'asc' ? 'desc' : 'asc';
};
